import { IconAtom } from "../atoms/iconAtom";
import { HorizontalLayout, VerticalLayout } from "./layout"

export function TitleDescription({title,description,className, style, icon2}){
    return(
        <div className={`horizontal standard-margin ${className}`} style={{ ...style }}>
            {icon2 && (<IconAtom icon2={icon2} color={"standard-text-color-light"} style={{ display: "flex", height: "100%", alignItems: "center", }}/>)}
            <p className="small-text-light title-description-title standard-min-width">{title}</p>
            <p className="small-text-dark standard-bold">{description}</p>
        </div>
    )
}
export function TitleFunction({title,children}){
    return(
        <div className="horizontal standard-margin">
            <p className="small-text-light title-description-title standard-min-width">{title}</p>
            {children}
        </div>
    )
}

export function Difficulty({ level, title }) {
  const levels = ["Makkelijk", "Gemiddeld", "Moeilijk"];
  const positions = ["10%", "50%", "100%"];
  const activeIndex = levels.indexOf(level);

  return (
    <VerticalLayout className="standard-small-margin-top" style={{ width: "220px",}}>
      <p className="small-text-light title-description-title standard-min-width"> {title}</p>
      <HorizontalLayout className="relative standard-small-margin-top" style={{ height: "12px", background: "var(--grey-50)", borderRadius: "6px" }} >
        <div
          style={{
            width: positions[activeIndex],
            height: "100%",
            background: "var(--primary-500)",
            borderRadius: "6px",
            transition: "width 0.3s",
          }}
        />
        {levels.map((lvl, idx) => {
          const isActive = idx <= activeIndex;
          const isCurrent = idx === activeIndex;
          return (
            <div
              key={lvl}
              style={{
                position: "absolute",
                top: "50%",
                left: positions[idx],
                transform: "translate(-50%, -50%)",
                width: isCurrent ? "20px" : "16px",
                height: isCurrent ? "20px" : "16px",
                borderRadius: "50%",
                background: isCurrent ? "var(--secondary-500)" : isActive ? "var(--primary-500)" : "var(--grey-50)",
                border: `2px solid ${isCurrent ? "var(--secondary-500)" : isActive ? "var(--primary-500)" : "var(--grey-100)"}`,
                transition: "all 0.3s",
              }}
            />
          );
        })}
      </HorizontalLayout>
      <HorizontalLayout className="space-between standard-small-margin-top">
        {levels.map((lvl, idx) => {
          const isActive = idx <= activeIndex;
          const isCurrent = idx === activeIndex;

          return (
            <span
              key={lvl}
              className="small-text-dark xsmall-text"
              style={{
                scale: isCurrent ? "1.15" : "1",
                fontWeight: isCurrent ? "700" : "500",
                color: isCurrent ? "var(--primary-500)" : isActive ? "var(--primary-400)" : "var(--grey-500)",
                transition: "all 0.3s",
              }}
            >
              {lvl}
            </span>
          );
        })}
      </HorizontalLayout>
    </VerticalLayout>
  );
}